import React, { useEffect, useRef, useState, useCallback, useContext  } from 'react';
import { Box, Button, Container, Typography, TextField, MenuItem, Card } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';

import { callPostApi } from '../../function/ApiCallFunction';
import { PrintOutlined } from '@mui/icons-material';

import GradientLoader from '../../components/CommanComponents/GradientLoader';
import { QRCodeCanvas } from 'qrcode.react';
import { DataContext } from '../../context/DataContext';

export default function QR() 
{
    const qrRef = useRef(null);
    const navigate  = useNavigate();

    const {loginData } = useContext(DataContext);
    const store_id = loginData?.store_info?.store_id;

    const [loading, setLoading] = useState(false);
    const [datar,   setDatar]   = useState([]);

    const [filterStatus,   setFilterStatus]   = useState('0');
    const [filterLotNo,    setFilterLotNo]    = useState('');
    const [filterLoadedNo, setFilterLoadedNo] = useState('');
    const [filterLimit,    setFilterLimit]    = useState(100);
    const fetchLimits    = [ "5", "10", "20", "50", "100", "250", "500", "1000"];

    /* ---------------- Print ---------------- */
    const handlePrint = useReactToPrint(
    {
        content: () => qrRef.current,
        documentTitle: 'QR Code',
        pageStyle: `
          @page { size: auto; margin: 20mm; }
          body {
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
            background: white !important;
            font-family: 'Roboto', sans-serif !important;
          }
          .MuiCard-root { page-break-inside: avoid; }
        `,
    });

    /* ---------------- API ---------------- */
    const printQRListApi = useCallback(async (qrcodeStatus = filterStatus,genLotNumber = filterLotNo,loadingNumber = filterLoadedNo,limit = filterLimit) =>
    {
        if (!store_id) return;

        try 
        {
            setLoading(true);
            const payload = { mod: "CASHI_QECODE_LIST", data_arr: { store_id, genLotNumber, loadingNumber,qrcodeStatus, start: '0', limit } };

            const apiResult = await callPostApi("cashi-qrcode", payload);
            if (apiResult.status === "200" && Array.isArray(apiResult.data)) 
            {
                const formattedData = apiResult.data.filter(i => i.redeem_status === '0').map((item, index) => ({
                    id: index + 1,
                    qr: item.qrcode_number || "NA",
                    expdate: item.expiry_date || "NA",
                    amount: item.amount || "NA",
                }));
                setDatar(formattedData); 
            } 
            else { setDatar([]);  }
        } 
        catch (err) {  console.error(err); } 
        finally { setLoading(false); }
    },[store_id, filterStatus, filterLotNo, filterLoadedNo, filterLimit]); 

    /* ---------------- Init ---------------- */
    useEffect(() => { printQRListApi(); }, [printQRListApi]);

    /* ---------------- Clear ---------------- */
    const clearFilter = () => 
    {
        setFilterStatus('0');
        setFilterLotNo('');
        setFilterLoadedNo('');
        setFilterLimit(100);
        printQRListApi('0', '', '', 100);
    };

    return (
      <Box>
          {loading && <GradientLoader text="Loading" />}        {/* // loader */}

          <Container>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
              <Button variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }} onClick={() => navigate(-1)}> Back </Button>
            </Box>

            <Typography variant="h6"  gutterBottom sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)', p: 1, color: '#ffffff',
                borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center',}}>
              <PrintOutlined sx={{ mx: 1 }} /> QR
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
              <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff', ml:1}}
                  onClick={handlePrint} > <PrintOutlined sx={{ mx: 1 }} /> Print </Button>
          </Box>
       
          {/* Filter section work */}
          <Box sx={{ display: 'flex',flexWrap:'wrap', gap: 2, mb: 2 }}>
            
            <TextField select label="Filter Status" value={filterStatus} onChange={e => { setFilterStatus(e.target.value); }} sx={{ minWidth: 140 }} >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="0">Pending</MenuItem>
                <MenuItem value="1">Loaded</MenuItem>
                <MenuItem value="2">Activated</MenuItem>
            </TextField>

            <TextField label="Lot Number" value={filterLotNo} onChange={(e) => setFilterLotNo(e.target.value)} sx={{ minWidth: 160 }} />
            <TextField  label="Loaded Number" value={filterLoadedNo} onChange={(e) => setFilterLoadedNo(e.target.value)} sx={{ minWidth: 160 }} />
              
            <TextField select label="Limit" value={filterLimit} onChange={(e) => setFilterLimit(e.target.value)} sx={{ minWidth: 140 }} >
                  {fetchLimits.map(value => ( <MenuItem value={value}>{value}</MenuItem>))}
            </TextField>

            <Button variant="outlined" color="primary" sx={{ height: 56 }} onClick={() => { printQRListApi(); }} > Apply Filter </Button>
            <Button variant="outlined" color="error" sx={{ height: 56 }} onClick={() => { clearFilter(); }} > Clear Filter </Button>
        </Box>
       
        <Box ref={qrRef} sx={{ display: 'flex', flexWrap: 'wrap', border: '2px dashed #ccc', borderRadius: '8px', p: 2 }}>
          
          {datar.length > 0 ? ( datar.map((item) => (
            <>
            <Card key={item.qr} sx={{ p: 1, m:1, background:'#fff', color:'#000', maxWidth:'150px', maxHeight:'auto' ,
                  boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px' }}>
              
              <Typography variant='h6' sx={{fontSize:'12px', color:'#333'}}>{item.qr || 'N/A'}</Typography>
              <Box sx={{mb:0, pb:0}}><QRCodeCanvas value={item.qr}  sx={{maxWidth:'100px'}} /> </Box>
              <Typography> ₹ {item.amount | 'NA'} </Typography>
              
          </Card>            
            </>
            )) ) : (
              <Typography sx={{ p: 3, color: '#888' }}>  No QR data available. </Typography> )}

        </Box>
      </Container>
    </Box>
  );
}
